import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { i18n, navigate } from "../../services";
import { AppState } from "../../store";
import {
    Button,
    ButtonActionGroup,
    BTN_SMALL,
    TYPE_SECONDARY,
} from "../../lib";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    user-select: none;
`;

const Heading = styled.h2`
    font-size: 30px;
    margin: 20px auto 20px auto;
`;

const Description = styled.div`
    font-size: 16px;
    text-align: center;
`;

const mapStateToProps = ({ user }: AppState) => ({ user });
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

class Header extends React.Component<Props> {
    onReturnClick = () => navigate.back();

    render() {
        return (
            <Container>
                <Heading>{i18n.get("merge.titleRequest")}</Heading>
                <Description>
                    {i18n.get("merge.requestDescription")}
                </Description>

                <ButtonActionGroup>
                    <Button
                        size={BTN_SMALL}
                        type={TYPE_SECONDARY}
                        messageId="form.return"
                        onClick={this.onReturnClick}
                    />
                </ButtonActionGroup>
            </Container>
        );
    }
}
export default connect(mapStateToProps)(Header);
